import { render, staticRenderFns } from "./HeroElement.vue?vue&type=template&id=2deeec16&"
import script from "./HeroElement.vue?vue&type=script&lang=js&"
export * from "./HeroElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports